import { useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { logout } from "../../api/api.js"; // Import the logout function
import { UserContext } from "../../contexts/CurrentUserContext.js";

function Logout() {
  const navigate = useNavigate();
  const { setUserData } = useContext(UserContext);

  useEffect(() => {
    logout()
      .then(() => {
        // Очищаем данные пользователя в контексте
        setUserData(null);
        navigate("/signin");
      })
      .catch((error) => {
        console.error("Ошибка при выходе:", error);
      });
  }, [navigate, setUserData]);

  return null; // Этот компонент ничего не рендерит, он только выполняет логику выхода.
}

export default Logout;
